import { render } from "./UiNode.vue?vue&type=template&id=af27bc34&ts=true"
import script from "./UiNode.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiNode.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiNode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af27bc34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af27bc34', __exports__)) {
    api.reload('af27bc34', __exports__)
  }
  
  module.hot.accept("./UiNode.vue?vue&type=template&id=af27bc34&ts=true", () => {
    api.rerender('af27bc34', render)
  })

}


export default __exports__